// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import HeaderIconButton from './header_icon_button';

export default HeaderIconButton;
